import { HiMiniLockClosed, HiMiniLockOpen } from "react-icons/hi2";
import { Button } from "./Button";

export type LockButtonProps = {
	locked: boolean;
	onClick: () => void;
};

export const LockButton = ({ locked, onClick }: LockButtonProps) => {
	return (
		<Button color="secondary" className="border-0 w-fit h-fit p-2" onClick={onClick}>
			{locked && <HiMiniLockClosed className="text-[20px] text-secondary" />}
			{!locked && <HiMiniLockOpen className="text-[20px] text-secondary" />}
		</Button>
	);
};
